
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const Home = lazy(() => import('../pages/home/page'));
const PolicyPage = lazy(() => import('../pages/policy/page'));
const TestPage = lazy(() => import('../pages/test/page'));
const CasesPage = lazy(() => import('../pages/cases/page'));
const LogisticsPage = lazy(() => import('../pages/logistics/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/policy',
    element: <PolicyPage />,
  },
  {
    path: '/test',
    element: <TestPage />,
  },
  {
    path: '/cases',
    element: <CasesPage />,
  },
  {
    path: '/logistics',
    element: <LogisticsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
